"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaForm = exports.TextArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _textareaStyles = require("./textarea-styles");

var _inputTitle = _interopRequireDefault(require("../ClassiInput/input-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TextArea = function TextArea(props) {
  return /*#__PURE__*/_react.default.createElement(_textareaStyles.Container, null, props.title && /*#__PURE__*/_react.default.createElement(_inputTitle.default, {
    error: props.error,
    title: props.title,
    subtitle: props.subtitle,
    required: props.isrequired
  }), /*#__PURE__*/_react.default.createElement(_textareaStyles.InputWrapper, {
    disabled: props.disabled,
    error: props.error
  }, /*#__PURE__*/_react.default.createElement(_textareaStyles.TextAreaField, props)));
};

exports.TextArea = TextArea;

var TextAreaForm = function TextAreaForm(props) {
  var input = props.input,
      meta = props.meta,
      width = props.width,
      onChange = props.onChange;
  var error = meta.error && meta.touched;

  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e);
    }

    input.onChange(e);
  };

  return /*#__PURE__*/_react.default.createElement(_textareaStyles.Wrapper, {
    width: width
  }, /*#__PURE__*/_react.default.createElement(TextArea, _extends({}, props, {
    name: input.name,
    value: input.value,
    onChange: handleChange,
    error: error
  })), error && /*#__PURE__*/_react.default.createElement(_textareaStyles.Erro, null, meta.error));
};

exports.TextAreaForm = TextAreaForm;